const style = {
  horizontalContainer: {
    display: 'flex',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
}
export default style
